export const CUSTOMERS_CURRENT_ENDPOINT = '/c/v1/customers/current';
